<template>
  <div v-if="isCartEmpty" class="empty-cart">
    <div class="empty-cart-title">您的購物車是空的噢！</div>
  </div>
  <div class="cart-order-container" v-else>
    <div class="load" v-if="isImageUnfinish">
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
      <div class="loading-text">程式運算中，請耐心等候</div>
    </div>
    <div id="cart-order" v-else>
      <h2 class="list-title">您的購物車</h2>
      <div class="orderlist">
        <div class="orderlist-title"></div>
        <div class="noshow price-title">
          <span>金額</span>
        </div>
        <div class="noshow amount-title">
          <span>數量</span>
        </div>
        <div class="noshow accessory-title" @click="closeAccessoryLightbox = false">
          <span>其他配件</span>
          <div class="zoomin-icon"></div>
        </div>
        <div class="noshow total-title">
          <span>合計</span>
        </div>
        <div class="clearall-title">
          <span v-on:click="deleteAllOrder">清除全部</span>
        </div>
      </div>
      <div class="order-wrap" v-for="(item,index) in cartOrder" :key="index">
        <div class="item-img" @click="lightboxControl(index)">
          <img v-bind:src="item.imageUrl" alt="item" />
          <p>點擊看大圖</p>
          <div class="zoomin-icon"></div>
        </div>
        <div class="item-name">
          <span>{{item.shape}}-{{item.style}}</span>
          <span>{{item.size.length}}{{item.size.unit}}{{item.size.weight}}錢{{item.size.way}}</span>
        </div>
        <div class="item-price">
          <span>TWD {{item.price}}</span>
        </div>
        <div class="item-amount">
          <div>
            <input type="number" v-bind:value="item.amount" min="1" readonly />
            <span class="arrowup" @click="increment(index)"></span>
            <span class="arrowdown" @click="decrement(index)"></span>
          </div>
        </div>
        <div class="item-accessory">
          <div class="m-accessory-title" @click="closeAccessoryLightbox = false">
            <span>其他配件</span>
            <div class="zoomin-icon"></div>
          </div>
          <div class="dropdown_title">
            <a href="#" @click.prevent="accessoryListShowDropDownControl(index)">
              <div class="title title-color">{{ selectedAccessory(item.accessory) }}</div>
              <i
                :class="{ 'fa-caret-up': showDropDown[`${index}`], 'fa-caret-down': !showDropDown[`${index}`] }"
                class="fa"
                aria-hidden="true"
              ></i>
            </a>
            <transition name="slide-fade">
              <div class="choice" v-if="showDropDown[`${index}`]">
                <ul>
                  <li v-for="accessory in accessoryListByStyle(item)" :key="accessory.id" class="list">
                    <span
                      @click="changeAccessory(index,accessory.id)"
                    >{{ `${accessory.name} (TWD ${accessory.price})` }}</span>
                  </li>
                </ul>
              </div>
            </transition>
          </div>
        </div>
        <div class="item-price">
          <span>TWD {{item.total}}</span>
        </div>
        <div class="close" v-on:click="deleteSingleOrder(index)">
          <img src="@/images/icon-close@2x.png" alt="close" />
        </div>
      </div>
      <div class="total-amount">
        <span>總額</span>
        <span>TWD {{sum}}</span>
      </div>
      <div class="order-note">
        <span>訂單備註</span>
        <textarea
          v-model="note"
          v-on:input="saveNote"
          placeholder="畫面呈現為示意圖，非正式製作的稿件，正式製作稿件將由專業人員編排製版完歡迎加入官方 Line@。"
        ></textarea>
        <p>此商品報價不是固定的，隨著金價浮動會更新結帳價格，若有未完成訂單者請注意，請盡快結帳來完成訂單。</p>
      </div>
      <div class="bottom-buttons-wrap">
        <router-link to="/gold/homepage">
          <button class="btn_gold btn">繼續購物</button>
        </router-link>
        <div class v-on:click="nextTocheckout">
          <button class="btn">結帳</button>
        </div>
      </div>
      <!-- <span class="special-member-text" v-if="isSpecialMember !== 1">
        還不是特約會員嗎？成為
        <router-link v-if="$store.getters.getDeviceSize < 585" to="/gold/member_mobile/contracted_store_form">特約廠商</router-link>
        <router-link to="/gold/member/contracted_store_form">特約廠商</router-link>以得到廠商報價
      </span> -->
      <div class="lightbox" v-bind:class="{'displaynone':closeLightbox}">
        <div class="center-container">
          <img v-bind:src="lightboxImg" />
          <div href="#" class="lightbox-close" @click="closeLightbox=!closeLightbox" v-body-scroll-lock="!closeLightbox">
            <img src="@/images/icon-close@2x-white.png" />
          </div>
        </div>
      </div>
    </div>
    <section>
      <div
        class="lightbox accessory-lightbox"
        v-bind:class="{'displaynone':closeAccessoryLightbox}"
        v-body-scroll-lock="!closeAccessoryLightbox"
      >
        <div class="center-container">
          <div class="accessory-title">
            <img src="@/images/accessory-title@2x.png" alt="其他配件說明" />
          </div>
          <div class="accessory-text">
            <p>每個金牌皆可選擇欲加購的配件。</p>
          </div>
          <div class="accessory-image">
            <div class="image-item">
              <img src="@/images/accessory-1@2x.png" alt="透明壓克力架" />
              <p>壓克力架（示意圖）</p>
            </div>
            <div class="image-item">
              <img src="@/images/accessory-2@2x.png" alt="紅色禮盒" />
              <p>禮盒（示意圖）</p>
            </div>
          </div>
          <div
            href="#"
            class="lightbox-close"
            @click="closeAccessoryLightbox=!closeAccessoryLightbox"
          >
            <img src="@/images/icon-close@2x-white.png" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CartOrder",
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.cartOrder = vm.getCartOrder();
      if (vm.cartOrder !== null) {
        vm.isCartEmpty = false;
        vm.getAccessoryList();
        // vm.getOrderPrice();
        vm.note = vm.getNote();
        vm.cartOrder.forEach((item, index) => {
          vm.showDropDown[`${index}`] = false;
          axios({
            url: `${item.imageUrl}`,
            method: "get"
          })
            .then(response => {
              if (response.data) {
                item.imageUrl = response.data;
              } else {
                // 防護措施，如果有無資料圖片，表示因為網路問題，圖還沒load出來就加入購物車，造成存圖錯誤
                vm.deleteSingleOrder(index, false);
              }
            })
            .catch(e => {
              alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
            });
        });
      }
    });
  },
  data() {
    return {
      isCartEmpty: true,
      isImageUnfinish: true,
      closeLightbox: true,
      cartOrder: "",
      note: "",
      sum: 0,
      lightboxImg: "",
      showDropDown: {
        0: false
      },
      closeAccessoryLightbox: true,
      accessoryList: []
    };
  },
  created() {
    this.timeToLeave();
  },
  watch: {
    cartOrder: {
      handler() {
        if (this.cartOrder !== null) {
          //check img loading
          let checkNum = 0;
          this.cartOrder.forEach(item => {
            if (item.imageUrl.substring(0, 4) == "data") {
              checkNum = checkNum + 1;
            }
          });
          if (checkNum == this.cartOrder.length) {
            this.isImageUnfinish = false;
          }
        }
      },
      deep: true
    }
  },
  methods: {
    accessoryListShowDropDownControl(index) {
      this.showDropDown[`${index}`] = !this.showDropDown[`${index}`];
      this.showDropDown = Object.assign({}, this.showDropDown);
    },
    async getAccessoryList() {
      try {
        let res = await this.$store.dispatch("getAccessoryList");
        this.accessoryList = res.data;
        this.getOrderPrice();
      } catch (e) {
        console.log(e);
      }
    },
    getCartOrder() {
      let order = JSON.parse(localStorage.getItem("cartorder"));
      return this.fixWrongData(order);
    },
    fixWrongData(order) {
      // 因應 202111 端調整，不能接受尺寸 6 cm，必須要 6.0，因此已存在在購物車者，需要修正
      order.forEach(i => {
        if (i.size.length === "6") {
          i.size.length = "6.0";
        }
      });
      localStorage.setItem("cartorder", JSON.stringify(order));
      return order;
    },
    getNote() {
      return JSON.parse(localStorage.getItem("cartorderNote"));
    },
    getOrderPrice() {
      let orderData = [];
      this.cartOrder.forEach(item => {
        if (this.$store.getters.getSpecialMemberState === 1) {
          item.size.type = "peer";
        } else {
          item.size.type = "normal";
        }
        orderData.push(JSON.parse(JSON.stringify(item.size)));
        item.size.way = this.$store.getters.getTransformWay(item.size.way);
        item.size.unit = this.$store.getters.getTransformUnit(item.size.unit);
      });
      axios({
        url: this.$store.getters.getGlobalUrl + "gold/calculate",
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        data: orderData
      })
        .then(response => {
          response.data.data.forEach((item, index) => {
            this.cartOrder[index].price = item.price;
            this.calcOrderTotol(index);
          });
          this.calcOrdersSum();
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    calcOrderTotol(index) {
      this.cartOrder[index].total =
        this.cartOrder[index].amount * this.cartOrder[index].price +
        this.cartOrder[index].amount *
          this.accessoryPrice(this.cartOrder[index].accessory);
    },
    calcOrdersSum() {
      this.sum = 0;
      this.cartOrder.map(item => {
        this.sum = parseFloat(this.sum) + parseFloat(item.total);
      });
    },
    updateCartOrderNum() {
      let cartorder = JSON.parse(localStorage.getItem("cartorder"));
      if (cartorder === null) {
        this.$store.dispatch("updateCartOrderNum", 0);
      } else {
        let updateCartOrderNum = 0;
        cartorder.forEach(item => {
          updateCartOrderNum = updateCartOrderNum + item.amount;
        });
        this.$store.dispatch("updateCartOrderNum", updateCartOrderNum);
      }
    },
    increment(index) {
      this.cartOrder[index].amount++;
      this.calcOrderTotol(index);
      this.calcOrdersSum();
      let updateCookie = JSON.parse(localStorage.getItem("cartorder"));
      updateCookie[index].amount++;
      localStorage.setItem("cartorder", JSON.stringify(updateCookie));
      this.updateCartOrderNum();
    },
    decrement(index) {
      if (this.cartOrder[index].amount > 1) {
        this.cartOrder[index].amount--;
        this.calcOrderTotol(index);
        this.calcOrdersSum();
        let updateCookie = JSON.parse(localStorage.getItem("cartorder"));
        updateCookie[index].amount--;
        localStorage.setItem("cartorder", JSON.stringify(updateCookie));
        this.updateCartOrderNum();
      }
    },
    deleteAllOrder() {
      let userResponse = confirm("您確定要清除全部嗎？");
      if (userResponse) {
        localStorage.removeItem("cartorder");
        localStorage.removeItem("cartorderNote");
        this.isCartEmpty = true;
        this.updateCartOrderNum();
      }
    },
    deleteSingleOrder(index, useConfirm = true) {
      let userResponse = useConfirm ? confirm("您確定要刪除嗎？") : true;
      if (userResponse) {
        this.cartOrder.splice(index, 1);
        let updateCookie = JSON.parse(localStorage.getItem("cartorder"));
        updateCookie.splice(index, 1);
        localStorage.setItem("cartorder", JSON.stringify(updateCookie));
        this.calcOrdersSum();
        this.showDropDown = {};
        this.cartOrder.forEach((item, index) => {
          this.showDropDown[`${index}`] = false;
        });
        if (this.cartOrder.length == 0) {
          this.isCartEmpty = true;
          localStorage.removeItem("cartorder");
          localStorage.removeItem("cartorderNote");
        }
        this.updateCartOrderNum();
      }
    },
    updateCookiePrice() {
      let updateCookie = JSON.parse(localStorage.getItem("cartorder"));
      updateCookie.forEach((item, index) => {
        item.price = this.cartOrder[index].price;
        item.total = this.cartOrder[index].total;
      });
      localStorage.setItem("cartorder", JSON.stringify(updateCookie));
    },
    saveNote() {
      let cookieContent = this.note;
      localStorage.setItem("cartorderNote", JSON.stringify(cookieContent));
    },
    lightboxControl(index) {
      this.closeLightbox = !this.closeLightbox;
      this.lightboxImg = this.cartOrder[index].imageUrl;
    },
    nextTocheckout() {
      this.updateCookiePrice();
      this.$router.push("/gold/cart/cart_info");
    },
    timeToLeave() {
      setTimeout(
        function() {
          this.$router.push("/gold/homepage");
        }.bind(this),
        3600000
      );
    },
    changeAccessory(index, accessoryId) {
      this.showDropDown[`${index}`] = !this.showDropDown[`${index}`];
      this.cartOrder[index].accessory = accessoryId;
      this.calcOrderTotol(index);
      this.calcOrdersSum();
      let updateCookie = JSON.parse(localStorage.getItem("cartorder"));
      updateCookie[index].accessory = accessoryId;
      localStorage.setItem("cartorder", JSON.stringify(updateCookie));
    }
  },
  computed: {
    accessoryListByStyle() {
      return function(item) {
        let componentAccessory = this.$store.getters.accessoryByComponentName(
          item.style
        );
        return this.accessoryList.filter(i =>
          componentAccessory.includes(i.id)
        );
      };
    },
    isSpecialMember() {
      return this.$store.getters.getSpecialMemberState;
    },
    selectedAccessory() {
      return function(accessoryId) {
        if (this.accessoryList.length === 0) {
          return "如需包裝請選擇";
        }
        let filterResult = this.accessoryList.filter(
          accessory => accessory.id == accessoryId
        );
        return `${filterResult[0].name} (TWD ${filterResult[0].price})`;
      };
    },
    accessoryPrice() {
      return function(accessoryId) {
        if (this.accessoryList.length === 0) {
          return 0;
        }
        let filterResult = this.accessoryList.filter(
          accessory => accessory.id == accessoryId
        );
        return filterResult[0].price;
      };
    }
  }
};
</script>

<style scoped lang="scss">
.empty-cart {
  min-height: calc(100vh - 377px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.empty-cart-title {
  font-size: 24px;
  color: $secondaryDeepColor1;
}
#cart-order {
  font-size: 17px;
  color: $secondaryDeepColor1;
  position: relative;
  padding: 120px 40px 60px;
  // max-width: 1102px;
  max-width: 1300px;
  margin: auto;

  @include table {
    padding: 126px 16px 16px 16px;
  }

  .list-title {
    font-size: 24px;
    text-align: left;
    margin: 0;
    position: absolute;
    top: 120px;
    @include table {
      top: 94px;
    }
  }
  .special-member-text {
    & > a {
      color: $primaryDeepColor;
    }
  }
}
.orderlist {
  display: grid;
  grid-template-columns: 2fr 2fr 1fr 1fr 2fr 1fr 100px;

  grid-template-rows: 1fr;
  align-items: center;
  border-bottom: 1px solid $primaryDeepColor;

  @include table {
    grid-template-columns: 1fr;
  }

  .orderlist-title {
    height: 100%;
    grid-column: 1 / span 2;
    @include table {
      grid-column: 1 / span 1;
      border: none;
    }
  }
  .price-title {
    height: 100%;
    line-height: 39px;
  }

  .amount-title {
    height: 100%;
    line-height: 39px;
  }

  .accessory-title {
    height: 100%;
    line-height: 39px;
    cursor: pointer;
  }

  .total-title {
    height: 100%;
    line-height: 39px;
    @include table {
      text-align: left;
    }
  }

  .clearall-title {
    text-decoration: underline;
    height: 100%;
    line-height: 39px;
    cursor: pointer;
    @include table {
      text-align: right;
    }
  }
  .noshow {
    @include table {
      display: none;
    }
  }
}
.zoomin-icon {
  width: 12px;
  height: 12px;
  display: inline-block;
  background-image: url("../../images/biger@2x.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-left: 3px;
}

.order-wrap {
  display: grid;
  grid-template-columns: 2fr 2fr 1fr 1fr 2fr 1fr 100px;
  grid-template-rows: 1fr;
  align-items: center;
  border-bottom: 1px solid $primaryDeepColor;
  @include table {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(1fr, 5);
  }
  .item-img {
    cursor: pointer;
    text-align: left;
    @media screen and (min-width: 768px) and (max-width: 907px) {
      text-align: center;
    }

    p {
      display: inline-block;
      font-size: 15px;
    }
    img {
      width: 40px;
      height: auto;
      vertical-align: middle;
      padding: 16px 8px;
      @include table {
        display: inline-block;
        margin: 0;
      }
      @media screen and (min-width: 768px) and (max-width: 907px) {
        display: block;
        margin: auto;
      }
    }
  }
  .item-name {
    text-align: left;
    span {
      display: block;
      line-height: 20px;
    }
  }
  .item-price {
    @include table {
      padding-top: 16px;
      padding-bottom: 16px;
      text-align: left;
    }
  }
  .close {
    position: relative;
    cursor: pointer;
    img {
      width: 16px;
      height: 16px;
      @include table {
        position: absolute;
        right: 0;
        bottom: 16px;
      }
    }
  }
}

.item-amount {
  @include table {
    text-align: left;
  }
  > div {
    position: relative;
    display: inline-block;
  }
  input[type="number"] {
    width: 90px;
    height: 45px;
    border: 1px solid $primaryDeepColor;
    box-sizing: border-box;
    padding: 16px;
    &::-webkit-inner-spin-button {
      appearance: none;
      width: 5px;
    }
  }
  .arrowup {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 6px 8px 6px;
    border-color: transparent transparent $primaryDeepColor transparent;
    position: absolute;
    top: 12px;
    right: 10px;
    cursor: pointer;
  }
  .arrowdown {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 6px 0 6px;
    border-color: $primaryDeepColor transparent transparent transparent;
    position: absolute;
    top: 27px;
    right: 10px;
    cursor: pointer;
  }
}
.item-accessory {
  .m-accessory-title {
    display: none;
    @include table {
      display: block;
      cursor: pointer;
      text-align: left;
      padding-top: 16px;
      padding-bottom: 16px;
    }
  }
}

.total-amount {
  margin-left: auto;
  width: 200px;
  text-align: right;
  font-size: 17px;
  font-weight: 800;
  span:first-child {
    display: block;
    padding-top: 20px;
  }
  span:last-child {
    display: block;
    font-size: 24px;
  }
}

.order-note {
  text-align: left;
  span {
    display: block;
    padding-bottom: 16px;
  }
  textarea {
    width: 100%;
    height: 129px;
    border: 1px solid $primaryDeepColor;
    font-size: 17px;
    color: $secondaryLightColor1;
    padding: 16px;
    box-sizing: border-box;
    @include table {
      padding: 11px 7px;
    }
  }
  p {
    font-size: 15px;
    color: #fb6e6b;
    margin-bottom: 30px;
  }
}

.bottom-buttons-wrap {
  > div {
    display: inline-block;
    @media screen and (max-width: 546px) {
      display: block;
    }
  }
  a {
    color: $primaryDeepColor;
  }
  .btn {
    @extend %button;
    margin: 10px 30px;
    @media screen and (max-width: 546px) {
      width: 90%;
    }
    @include phone {
      margin: 10px 0;
    }
  }
  .btn_gold {
    color: $primaryDeepColor;
    background-color: transparent;
    border: 1px $primaryDeepColor solid;
    &:hover {
      color: $secondaryColor3;
      background-color: $primaryDeepColor;
    }
  }
  button:last-child {
    margin-left: 27px;
    @media screen and (max-width: 546px) {
      margin: 8px 10px;
    }
  }
}

.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1111111;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  .center-container {
    flex: 0 0 80vmin;
    background-color: $secondaryColor3;
    @include phone {
      flex: 0 0 90vmin;
    }
  }
  img {
    width: 100%;
    height: auto;
    max-height: 80vh;
    object-fit: contain;
  }
  .lightbox-close {
    box-sizing: border-box;
    max-width: 45px;
    max-height: 45px;
    padding: 8px;
    background: $primaryDeepColor;
    color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.accessory-lightbox {
  .center-container {
    padding: 2%;
    color: $primaryDeepColor;
    font-size: 17px;
    .accessory-title {
      width: 30%;
      margin: auto;
      @include betweenPhoneTable {
        width: 180px;
      }
    }
    .accessory-image {
      display: flex;
      justify-content: space-around;
      align-items: flex-start;
      @include betweenPhoneTable {
        flex-flow: column;
        align-items: center;
      }
      .image-item:first-child {
        margin-right: 5%;
        @include betweenPhoneTable {
          margin-right: 0;
          img {
            height: 180px;
            object-fit: cover;
          }
        }
      }
      .image-item {
        @include betweenPhoneTable {
          width: 50%;
        }
      }
    }
  }
}
.displaynone {
  display: none;
}

//loading
.load {
  display: flex;
  min-height: calc(100vh - 377px);
  justify-content: center;
  align-items: center;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #a8894c;
}
.loading-text {
  color: #a8894c;
  margin-left: 20px;
}
@keyframes loadingC {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}

//dropdown
.list a,
.list span {
  &:hover,
  &:focus {
    color: $secondaryColor3;
    background-color: $primaryLightColor;
  }
}
.dropdown_title {
  position: relative;
  padding: 16px 0;
  p {
    text-align: left;
    @include tablePro {
      text-align: center;
    }
  }
  a,
  span {
    color: $secondaryLightColor1;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 9px;
    border: 1px $primaryDeepColor solid;
    margin-top: -1px;
    background-color: $secondaryColor3;
  }
  .title-color {
    color: $secondaryDeepColor1;
  }
}

ul {
  display: block;
  list-style-type: none;
  margin: 0;
  padding: 0;
  margin: auto;
}
.choice {
  position: absolute;
  width: 100%;
  z-index: 1;
  span {
    color: $secondaryDeepColor1;
  }
}
.fa {
  font-size: 21px;
  margin-left: auto;
  color: $primaryDeepColor;
}
</style>
